import { render } from "./CustomerSecurePortal.vue?vue&type=template&id=48b27009"
import script from "./CustomerSecurePortal.vue?vue&type=script&lang=js"
export * from "./CustomerSecurePortal.vue?vue&type=script&lang=js"

import "./CustomerSecurePortal.vue?vue&type=style&index=0&id=48b27009&lang=css"

import exportComponent from "C:\\Users\\HanYaqoob\\Desktop\\REPOS\\DebtCrmPortalUI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__